import { createRoot } from 'react-dom/client'
import React from 'react'
import AppPassword from './appPassword/AppPassword'

const domNode = document.getElementById('matrix-shortcode-password')

if(domNode) {
    const root = createRoot(domNode)

    root.render(<AppPassword />)
}